// 新协议
function kkmhhybrid_switch_page (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "switch_page",
    },
    param: {
        // action_type: opt.actionTarget.action_type,
        // extra_params: opt.actionTarget,
        // progress_bar: opt.progress_bar
        action_type: opt.action_type,
        extra_params: opt.extra_params,
        params:opt.params || {},
        progress_bar: opt.progress_bar
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
// 新协议
function kkhybrid_navAction (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "navAction",
    },
    param: {
        actionTarget: {
          action_type: opt.action_type,
          ...opt.extra_params,
          progress_bar: opt.progress_bar || ''
        }
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
/**
 * 切换页面(通用跳转)<br>
 * kkmhhybrid://switch_page{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=81202484}<br>
 * @param {Object} opt 参数对象
 * @param {Object} opt 跳转目标页面类型 详情参考https://wiki.quickcan.com/pages/viewpage.action?pageId=16265340
 * @param {Object} opt.action_type 跳转目标页面类型 详情参考https://wiki.quickcan.com/pages/viewpage.action?pageId=16265340
 * @param {Object} opt.extra_params 跳转目标页面类型的其他参数 详情参考https://wiki.quickcan.com/pages/viewpage.action?pageId=16265340其他参数
 * @param {Int/String} opt.progress_bar 是否显示进度条 1.H5 新开 webview 的方式跳转2. H5跳转H5  webview之间跳转使用,其它情况无效果
 * @param {Function} opt.callback 回调函数
 */
function switch_page (opt, criticalAppVersion) {
  if(!criticalAppVersion) {
    criticalAppVersion = window.kkBaseInfo.criticalAppVersion;
  }
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(allow) {
    // console.log('switch')
    kkmhhybrid_switch_page(opt);
  } else {
    // console.log('nav')
    kkhybrid_navAction(opt)
  }
}

export default switch_page;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/switch_page/index.js